








import { defineComponent } from '@vue/composition-api';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';
import AdClient from '@/bundles/Ad/models/AdClient';
import { ICreateAdClientDto } from '@/bundles/Ad/dto';

import AdClientFormBase from '@/bundles/Ad/components/AdClientFormBase.vue';

export default defineComponent({
  name: 'AdClientCreateForm',

  components: {
    AdClientFormBase,
  },

  emits: ['item:refresh', 'form:close'],

  setup (_, { emit }) {
    const { defaultAdClientData, createClient, createLoading } = useAdClient();
    const adClient = new AdClient(defaultAdClientData);

    async function submitEventHandler (data: ICreateAdClientDto) {
      await createClient(data);
      emit('form:close');
      emit('item:refresh');
    }

    return {
      adClient,
      createLoading,
      submitEventHandler,
    };
  },
});
